export default "/assets/zendesk_logo-d638c8a36f12da515af465cc1ba518f35deb28cb3871dd731a52d14b8764b84f.png";